import React, { Component } from "react";
import queryString from 'query-string'
import "./Footer.scss"

class Footer extends Component {
  constructor() {
    super();
    this.toggleCreditScreen = this.toggleCreditScreen.bind(this);
    this.state = {
      showCreditScreen: false,
      AppWebView: false
    }
  }
  componentDidMount() {
    window.addEventListener("toggleCreditScreenBTN", this.toggleCreditScreen);
    const qs = queryString.parse(window.location.search);
    if (qs.appview == 1 && qs) {
      this.setState({
        AppWebView: true
      })
    }
  }
  toggleCreditScreen() {
    this.setState({
      showCreditScreen: !this.state.showCreditScreen
    })
  }
  render() {
    return (
      <footer>
        <div className="credits-button" style={{ display: !this.props.isActive ? "none" : this.state.showCreditScreen ? "none" : "" }} onClick={() => {
        // <div className="credits-button" style={{ display: !this.props.isActive ? "" : this.state.showCreditScreen ? "" : "" }} onClick={() => {
          window.dispatchEvent(new CustomEvent("toggleCreditScreen", {
            "detail": "toggleCreditScreen"
          }));
          window.dispatchEvent(new CustomEvent("toggleCreditScreenBTN", {
            "detail": "toggleCreditScreenBTN"
          }));
        }}>
          קרדיטים
      </div>
        <div id="footer" style={{ display: this.state.AppWebView ? "none" : "" }}>
          <div className="padding">
            <div className="policy">
              <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" title="" target="_blank">תנאי שימוש</a> | <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" title="" target="_blank">מדיניות פרטיות</a>
            </div>
            <a href={`https://www.yit.co.il/?utm_source=${encodeURIComponent("www.z.ynet.co.il/mShort/content/2019/FrogiChoice2019")}&utm_medium=referral&utm_campaign=Footer`} title="YIT" target="_blank" rel="noopener noreferrer">
              <div className="yitlogo"></div>
            </a>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.jsx